import { isEmpty } from 'lodash-es';

// SQL injection characters to block: quotes, semicolons, backslashes, SQL comments, wildcards, operators
const SQL_INJECTION_REGEX = /['";\\%_<>=()]/;

/**
 * Validates a workspace name according to security rules:
 * - Must not be empty
 * - Cannot have leading or trailing spaces
 * - Cannot contain SQL injection characters: ' " ; \ % _ < > = ( )
 *
 * @param value - The workspace name to validate
 * @returns Error message if validation fails, null if valid
 */
export function validateWorkspaceName(value: string): string | null {
	if (isEmpty(value)) {
		return 'Workspace name is required';
	}

	const trimmedValue = value.trim();
	if (trimmedValue !== value) {
		return 'Workspace name cannot have leading or trailing spaces';
	}

	if (SQL_INJECTION_REGEX.test(trimmedValue)) {
		return 'Workspace name cannot contain special characters';
	}

	return null;
}
